// src/components/BarcodeScanner.tsx

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BarcodeScanner: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const MIN_BARCODE_LENGTH = 8; // Adjust based on your barcode length
    const MAX_TIME_BETWEEN_KEYS = 1000; // Max time (ms) between keystrokes

    let buffer = '';
    let lastKeyTime = Date.now();

    const handleKeyDown = (e: KeyboardEvent) => {
      const currentTime = Date.now();
      const timeDifference = currentTime - lastKeyTime;

      if (timeDifference > MAX_TIME_BETWEEN_KEYS) {
        buffer = ''; // Reset buffer if time between keys is too long
      }

      lastKeyTime = currentTime;

      if (e.key === 'Enter') {
        if (buffer.length >= MIN_BARCODE_LENGTH) {
          processBarcode(buffer);
        }
        buffer = ''; // Reset buffer after processing
      } else {
        buffer += e.key;
      }
    };

    const processBarcode = async (scannedBarcode: string) => {
      console.log('Barcode scanned:', scannedBarcode);

      try {
        // Send GET request to decode the barcode
        const response = await fetch(`/api/plates/${encodeURIComponent(scannedBarcode)}/decode`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          const plateId = data.plateId;

          if (plateId) {
            // Redirect to the plate details page
            navigate(`/plates/${plateId}`);
          } else {
            console.error('No plateId found in response');
            alert('Invalid barcode scanned.');
          }
        } else {
          console.error('Barcode decoding failed with status:', response.status);
          alert('Invalid barcode scanned.');
        }
      } catch (error) {
        console.error('Error processing barcode:', error);
        alert('An error occurred while processing the barcode.');
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);

  return null; // This component doesn't render any visible elements
};

export default BarcodeScanner;
